export function normalizeSearchQuery(searchQuery: string | null | undefined): string {
    return (searchQuery ?? "").trim().toLowerCase()
}

export function hasSearchQuery(searchQuery: string | null | undefined): boolean {
    return normalizeSearchQuery(searchQuery) !== ""
}

function textMatchesSearch(value: unknown, normalizedQuery: string): boolean {
    if (!normalizedQuery) {
        return false
    }
    if (value == null) {
        return false
    }
    return value.toString().toLowerCase().includes(normalizedQuery)
}

export function primitiveValueMatchesSearch(value: unknown, normalizedQuery: string): boolean {
    if (!normalizedQuery) {
        return false
    }
    if (value === null) {
        return "null".includes(normalizedQuery)
    }
    const valueType = typeof value
    if (valueType === "string" || valueType === "number" || valueType === "boolean") {
        return textMatchesSearch(value, normalizedQuery)
    }
    return false
}

export function nodeMatchesSearch(name: string, value: unknown, normalizedQuery: string): boolean {
    return textMatchesSearch(name, normalizedQuery) || primitiveValueMatchesSearch(value, normalizedQuery)
}

export function configContainsSearchMatch(config: unknown, normalizedQuery: string): boolean {
    if (!normalizedQuery || config == null) {
        return false
    }
    if (primitiveValueMatchesSearch(config, normalizedQuery)) {
        return true
    }
    if (Array.isArray(config)) {
        return config.some((item) => configContainsSearchMatch(item, normalizedQuery))
    }
    if (typeof config !== "object") {
        return false
    }

    return Object.entries(config as Record<string, unknown>).some(([key, value]) => {
        if (nodeMatchesSearch(key, value, normalizedQuery)) {
            return true
        }
        return configContainsSearchMatch(value, normalizedQuery)
    })
}
